import type { VehicleService } from '../../services/vehicle.service';
import type { VehicleData } from '../types';

/** Shown when the lookup answers without vehicle data and without its own wording. */
export const NO_VEHICLE_DETAILS_MESSAGE =
  'No vehicle details found for this plate and state. Check both and try again.';

/**
 * Shown inline (amber hint, not a toast) when AskOtto has nothing for the plate and the
 * operator can proceed by typing Year, Make and Model. Used by every vehicle edit form.
 */
export const MANUAL_ENTRY_MESSAGE =
  'Vehicle details not found. Please enter the Year, Make, and Model manually.';

export interface FetchVehicleDataCallbacks {
  onSuccess: (data: VehicleData) => void;
  onFailure?: (message: string) => void;
  onError: (message: string) => void;
}

/**
 * Shared fetch vehicle flow: call getVehicleData(payload), then invoke callbacks based on response.
 * Caller should set isLoading = true before calling and set isLoading = false in each callback.
 */
export function runFetchVehicleData(
  vehicleService: VehicleService,
  payload: { license_plate: string; state: string; persist?: boolean },
  callbacks: FetchVehicleDataCallbacks
): void {
  vehicleService.getVehicleData(payload).subscribe({
    next: response => {
      if (response.status && response.data) {
        callbacks.onSuccess(response.data);
      } else {
        callbacks.onFailure?.(response.message || NO_VEHICLE_DETAILS_MESSAGE);
      }
    },
    error: error => {
      const message =
        error?.error?.message ||
        error?.message ||
        'Failed to fetch vehicle data. Please try again.';
      callbacks.onError(message);
    },
  });
}
